import Splide from '@splidejs/splide';

const EL = '.js-reviews';
const TOGGLES = document.querySelectorAll('.js-reviews__textbox-more')

if (document.querySelector(EL)) {
  TOGGLES.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      const el = e.currentTarget;

      el.closest('.reviews__item').classList.add('is-open')

      e.preventDefault()
    })
  })

  const slider = new Splide(EL, {
    fixedWidth: '440px',
    pagination: false,
    arrows: true,
    gap: 20,
    breakpoints: {
      1024: {
        fixedWidth: '282px',
        gap: 10,
      },
      767: {
        arrows: false,
        pagination: true,
      }
    }
  }).mount();
}
